import { ElementRef, Directive, Input } from '@angular/core';

@Directive({
  selector: 'palantir-dropdown-item',
  standalone: false,
})
export class DropdownItemDirective {
  @Input() public value?: string;

  public constructor(public readonly elementRef: ElementRef<HTMLElement>) {}
}
